__turbopack_context__.v({
  "header": "TopDestinations-module-scss-module__2bLpTW__header",
  "root": "TopDestinations-module-scss-module__2bLpTW__root",
});
